import jQuery from 'jquery'

class Bookmarks {
    
    /**
     * Construct component
     * @param bookmarks
    */
    constructor(bookmarks) {
        
        /**
         * Bookmarks mapping
         * @type object
        */
        this.map = {}
        
        //Generate ID map
        jQuery.each(bookmarks, (i, id) => {
            this.map[id] = true
        })
        
    }
    
    /**
     * Determine whether the provided item is bookmarked
     * @param id
     * @return boolean
    */
    has(id) {
        return this.map.hasOwnProperty(id)
    }
    
}

export default Bookmarks